import { Injectable } from '@angular/core';
import { UsersApiService } from '@core/services/users-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PaginationState } from '@shared/models/pagination-state';
import { User } from '@shared/models/user';
import { ToastService } from '@shared/services/toast.service';
import { catchError, map, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { loadGroupUsers, loadGroupUsersFailure, loadGroupUsersSuccess } from '../actions/load-group-users.actions';
import { SessionService } from '@shared/services/session.service';

@Injectable()
export class LoadGroupUsersEffects {
  constructor(
    private actions$: Actions,
    private usersApiService: UsersApiService,
    private sessionService: SessionService,
    private toastService: ToastService,
  ) {}

  loadGroupUsers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadGroupUsers),
      withLatestFrom(this.sessionService.getUserType()),
      switchMap(([_action, userType]) => {
        return this.usersApiService
          .index(
            { page: 1, per_page: 1000 } as PaginationState,
            { user_type: userType, user_status: 'active' },
            { key: 'id', direction: 'desc' },
          )
          .pipe(
            map((response: { data: User[]; meta: PaginationState }) => {
              return loadGroupUsersSuccess({ data: response.data });
            }),
            catchError((error) => {
              return of(loadGroupUsersFailure({ error }));
            }),
          );
      }),
    ),
  );

  loadGroupUsersFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadGroupUsersFailure),
        tap(({ error }) => {
          const errorMessage =
            typeof error.error?.errors === 'string'
              ? error.error.errors
              : 'Failed to load users. Please try again later.';
          this.toastService.showToast('error', errorMessage, 10000);
        }),
      ),
    { dispatch: false },
  );
}
